$(function () {
    $('.uk-accordion-title .info-icon').click(function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        const $t = $(this);
        const target = $t.data('target');
        UIkit.modal(document.getElementById(target)).show();
    });
});